import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppLoaderApp } from './AppLoaderApp';

// см. https://mobx.js.org/installation.html#use-spec-compliant-transpilation-for-class-properties
if (
  !new (class {
    x;
    // eslint-disable-next-line no-prototype-builtins
  })().hasOwnProperty('x')
)
  throw new Error('Transpiler is not configured correctly');

document.body = document.createElement('body');
document.body.innerHTML = '<div id="root"></div>';

const container = document.getElementById('root');

const appRoot = createRoot(container as Element);

// TODO use initAppUi here
appRoot.render(<AppLoaderApp />);
